import { HttpStatusCode } from '@angular/common/http';
import { CheckoutOffer } from '../checkout/checkout-offer.interface';

export interface QuoteResponse {
  status: HttpStatusCode;
  interactionId: string;
  personId: string;
  items: QuoteItem[];
  offer: CheckoutOffer;
}

export interface QuoteItem {
  id: string;
  operationalStatusAtPos: string;
}
